import React from 'react'
import {Redirect, Route} from 'react-router-dom'
import {Context} from '../Context'

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Context.Consumer>
  {
    ({globalState, actions}) =>
      <Route
        {...rest}
        render={props =>
          globalState.user
          ? <Component {...props} />
          : <Redirect to={{pathname: "/",state: { from: props.location }}}/>
        }
      />
  }
  </Context.Consumer>
);

export default PrivateRoute



// WEBPACK FOOTER //
// ./src/components/PrivateRoute.js